import React, { Component } from 'react'
import { ImHome, ImPrinter } from 'react-icons/im'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const T = {
  bg: '#f1f5f9', card: '#ffffff', border: '#e8edf5',
  blue: '#3b82f6', blueD: '#2563eb', navy: '#0f172a',
  txt: '#1e293b', txt2: '#64748b', muted: '#94a3b8',
  green: '#16a34a', greenBg: '#f0fdf4', greenBdr: '#bbf7d0',
  red: '#dc2626', redBg: '#fef2f2', redBdr: '#fecaca',
  warn: '#f59e0b', warnBg: '#fffbeb', warnBdr: '#fde68a',
  r: 16, rsm: 10,
  shadow: '0 1px 3px rgba(15,23,42,.06)',
  shadowMd: '0 4px 16px rgba(15,23,42,.08)',
  font: "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"
}

const S = {
  page: { background: T.bg, minHeight: '100vh', fontFamily: T.font, color: T.txt },
  header: {
    background: T.card, borderBottom: `1px solid ${T.border}`,
    padding: '20px 32px', display: 'flex', alignItems: 'center',
    gap: 12, position: 'sticky', top: 0, zIndex: 10,
    boxShadow: T.shadow
  },
  btnBack: {
    background: 'none', border: `1px solid ${T.border}`, borderRadius: T.rsm,
    padding: '8px 14px', cursor: 'pointer', color: T.txt2,
    fontSize: 14, display: 'flex', alignItems: 'center', gap: 6,
    transition: 'all .15s'
  },
  btnPrint: {
    background: T.navy, border: 'none', borderRadius: T.rsm,
    padding: '8px 16px', cursor: 'pointer', color: '#fff',
    fontSize: 14, display: 'flex', alignItems: 'center', gap: 6,
    marginLeft: 'auto', transition: 'background .15s'
  },
  btnEdit: {
    background: T.blue, border: 'none', borderRadius: T.rsm,
    padding: '8px 14px', cursor: 'pointer', color: '#fff',
    fontSize: 13, display: 'flex', alignItems: 'center', gap: 5
  },
  title: { fontSize: 22, fontWeight: 700, color: T.navy, margin: 0 },
  content: { maxWidth: 1100, margin: '0 auto', padding: '28px 24px' },
  card: {
    background: T.card, borderRadius: T.r, border: `1px solid ${T.border}`,
    boxShadow: T.shadow, marginBottom: 20, overflow: 'hidden'
  },
  cardHeader: {
    padding: '16px 24px', borderBottom: `1px solid ${T.border}`,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
  },
  cardTitle: { fontSize: 14, fontWeight: 600, color: T.txt2, textTransform: 'uppercase', letterSpacing: '.06em' },
  cardBody: { padding: '20px 24px' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 },
  field: { marginBottom: 14 },
  label: { fontSize: 11, fontWeight: 600, color: T.muted, textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 4, display: 'block' },
  value: { fontSize: 15, color: T.txt, lineHeight: 1.5 },
  badge: (color, bg, bdr) => ({
    display: 'inline-flex', alignItems: 'center',
    padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
    color, background: bg, border: `1px solid ${bdr}`
  }),
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: T.txt2, textTransform: 'uppercase', letterSpacing: '.07em', background: '#f8fafc', borderBottom: `2px solid ${T.border}` },
  td: { padding: '11px 14px', borderBottom: `1px solid ${T.border}`, color: T.txt, verticalAlign: 'middle' },
  btnDl: {
    background: T.greenBg, border: `1px solid ${T.greenBdr}`, borderRadius: T.rsm,
    padding: '6px 12px', cursor: 'pointer', color: T.green,
    fontSize: 12, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 5
  },
  btnSm: (color, bg, bdr) => ({
    background: bg, border: `1px solid ${bdr}`, borderRadius: 8,
    padding: '5px 10px', cursor: 'pointer', color,
    fontSize: 12, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4
  }),
  input: {
    width: '100%', padding: '8px 12px', border: `1px solid ${T.border}`,
    borderRadius: T.rsm, fontSize: 14, color: T.txt, background: T.card,
    outline: 'none', boxSizing: 'border-box'
  },
  select: {
    width: '100%', padding: '8px 12px', border: `1px solid ${T.border}`,
    borderRadius: T.rsm, fontSize: 14, color: T.txt, background: T.card,
    outline: 'none', cursor: 'pointer'
  },
  alertErr: {
    background: T.redBg, border: `1px solid ${T.redBdr}`, borderRadius: T.rsm,
    padding: '12px 16px', color: T.red, fontSize: 14, marginBottom: 16
  },
  spinner: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '80px 0', flexDirection: 'column', gap: 16
  },
  noData: { padding: '24px', textAlign: 'center', color: T.muted, fontSize: 14 },
  divider: { border: 'none', borderTop: `1px solid ${T.border}`, margin: '0' },
  photoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, padding: '20px 24px' },
  photo: { borderRadius: T.rsm, overflow: 'hidden', background: '#f8fafc', aspectRatio: '4/3' },
  photoImg: { width: '100%', height: '100%', objectFit: 'cover' },
  photoCover: {
    borderRadius: T.rsm, overflow: 'hidden', background: '#f8fafc',
    maxWidth: 380, margin: '0 auto', aspectRatio: '4/3'
  },
}

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
const EJERCICIOS = Array.from({ length: 16 }, (_, i) => new Date().getFullYear() - 5 + i - 5).map(String)
// Genera años desde 10 años atrás hasta 5 años adelante, centrado en el año actual

function formatMoney(amount) {
  if (isNaN(amount) || amount === '' || amount === null) return '-'
  try {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount)
  } catch { return '-' }
}

function Badge({ children, type = 'default' }) {
  const map = {
    activo: [T.green, T.greenBg, T.greenBdr],
    inactivo: [T.red, T.redBg, T.redBdr],
    warn: [T.warn, T.warnBg, T.warnBdr],
    default: [T.txt2, '#f1f5f9', T.border],
  }
  const [c, b, bd] = map[type] || map.default
  return <span style={S.badge(c, b, bd)}>{children}</span>
}

function Field({ label, value, preWrap }) {
  return (
    <div style={S.field}>
      <span style={S.label}>{label}</span>
      <div style={{ ...S.value, whiteSpace: preWrap ? 'pre-wrap' : 'normal' }}>
        {value || <span style={{ color: T.muted }}>—</span>}
      </div>
    </div>
  )
}

function DownloadBtn({ fileUrl, filename, label = 'Descargar' }) {
  if (!fileUrl) return <span style={{ color: T.muted, fontSize: 13 }}>Sin archivo</span>
  return (
    <button style={S.btnDl} onClick={() => ElementsDataService.downloadS3File(`?fileName=${fileUrl}`, filename)}>
      ⬇ {label}
    </button>
  )
}

function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', backdropFilter: 'blur(4px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: T.card, borderRadius: T.r, padding: 28, maxWidth: 380, width: '90%', boxShadow: T.shadowMd }}>
        <div style={{ fontSize: 16, fontWeight: 600, color: T.navy, marginBottom: 8 }}>¿Confirmar acción?</div>
        <div style={{ fontSize: 14, color: T.txt2, marginBottom: 24 }}>{message}</div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button style={S.btnSm(T.txt2, '#f1f5f9', T.border)} onClick={onCancel}>Cancelar</button>
          <button style={S.btnSm('#fff', T.red, T.red)} onClick={onConfirm}>Eliminar</button>
        </div>
      </div>
    </div>
  )
}

class DomicilioReporteComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: this.props.match.params.id,
      tipoVialidad: 'Calle',
      calle: '', colonia: '', cp: '', estado: '', municipio: '',
      numeroExt: '', numeroInterior: '', telefono: '',
      estatus: '', control: '', tipo: '', notas: '',
      tipoInmueble: '', referencias: '', especificaciones: '',
      entreCalle1: '', entreCalle2: '',
      personasFisicas: [], sociedades: [],
      comprobanteDomicilioFileUrl: '',
      contratoArrendamientoFileUrl: '',
      croquisFileUrl: '',
      listaSociedadesDocumentosPersonasFisicas: [],
      gastos: [],
      gastosLoading: false,
      portadaData: '',
      fotografiasGalleryDataArray: [],
      loading: true,
      imageCount: '',
      ejercicio: new Date().getFullYear(),
      periodo: MESES[new Date().getMonth()],
      resumenContrato: '',
      fechaVencimientoContrato: '',
      rentaMensual: '',
      formaPago: '',
      noCuenta: '',
      arrendadorName: '',
      idArrendadorFileURL: '',
      propietarioIntermediario: '',
      documentoAcreditacionPosesionURL: '',
      fechaInactivo: '',
      selectedSavedButtonId: null,
      currentHistorialSociedadDomicilioItem: null,
      errorMsg: '',
      confirmDelete: null,
      pfCollapsed: true,
      fotosCollapsed: true,
      // ── Inline gasto form ──
      showGastoForm: false,
      gastoFormMode: 'new',
      gastoFormId: null,
      gastoFormTipo: '',
      gastoFormCantidad: '',
      gastoFormFecha: '',
      gastoFormNotas: '',
      gastoFormFile: null,
      gastoFormFileUrl: '',
      gastoFormSaving: false,
      gastoFormError: '',
    }
  }

  componentDidMount() {
    if (!AuthenticationService.haveAuthorization('READ_DOMICILIOS')) {
      this.setState({ errorMsg: 'Usuario no autorizado', loading: false })
      setTimeout(() => this.props.history.push('/login'), 1500)
      return
    }
    if (Number(this.state.id) === -1) { this.setState({ loading: false }); return }
    this.loadData()
  }

  loadData() {
    const { id, ejercicio, periodo } = this.state
    this.setState({ loading: true })

    Promise.all([
      ElementsDataService.retrieveElement('domicilios', id),
      ElementsDataService.retrieveElement(`domicilios/gastos/${ejercicio}/${periodo}`, id),
      ElementsDataService.retrieveElement('domicilios/galeria', id),
    ]).then(([domRes, gastosRes, galeriaRes]) => {
      const d = domRes.data
      this.setState({
        calle: d.calle, tipoVialidad: d.tipoVialidad, colonia: d.colonia,
        cp: d.cp, estado: d.estado, municipio: d.municipio,
        numeroExt: d.numeroExt, numeroInterior: d.numeroInterior,
        telefono: d.telefono, estatus: d.estatus, control: d.control,
        tipo: d.tipo, notas: d.notas, tipoInmueble: d.tipoInmueble,
        referencias: d.referencias, especificaciones: d.especificaciones,
        entreCalle1: d.entreCalle1, entreCalle2: d.entreCalle2,
        personasFisicas: d.personasFisicas, sociedades: d.sociedades,
        comprobanteDomicilioFileUrl: d.comprobanteDomicilioFileUrl,
        contratoArrendamientoFileUrl: d.contratoArrendamientoFileUrl,
        croquisFileUrl: d.croquisFileUrl,
        listaSociedadesDocumentosPersonasFisicas: d.listaSociedadesDocumentosPersonasFisicas,
        resumenContrato: d.resumenContrato,
        fechaVencimientoContrato: d.fechaVencimientoContrato,
        rentaMensual: d.rentaMensual, formaPago: d.formaPago,
        noCuenta: d.noCuenta, arrendadorName: d.arrendadorName,
        idArrendadorFileURL: d.idArrendadorFileURL,
        propietarioIntermediario: d.propietarioIntermediario,
        documentoAcreditacionPosesionURL: d.documentoAcreditacionPosesionURL,
        fechaInactivo: d.fechaInactivo,
        gastos: gastosRes.data,
        loading: false,
      })

      // Gallery
      const imageCount = galeriaRes.data?.imageCount
      if (imageCount > 0) {
        this.setState({ imageCount })
        ElementsDataService.getImageFile(`?fileName=Domicilios/domicilio_${id}/galeria/0.jpg`)
          .then(r => this.setState({ portadaData: URL.createObjectURL(r) }))
        if (imageCount > 1) {
          for (let i = 1; i < imageCount; i++) {
            const idx = i
            ElementsDataService.getImageFile(`?fileName=Domicilios/domicilio_${id}/galeria/${idx}.jpg`)
              .then(r => {
                const arr = [...this.state.fotografiasGalleryDataArray]
                arr[idx - 1] = URL.createObjectURL(r)
                this.setState({ fotografiasGalleryDataArray: arr })
              })
          }
        }
      }
    }).catch(() => {
      this.setState({ loading: false, errorMsg: 'Error al cargar los datos del domicilio.' })
    })
  }

  updateFecha() {
    this.setState({ loading: true })
    const { currentHistorialSociedadDomicilioItem } = this.state
    ElementsDataService.updateElement('historia-sociedad-domicilio', currentHistorialSociedadDomicilioItem.id, currentHistorialSociedadDomicilioItem)
      .then(() => {
        this.setState({ selectedSavedButtonId: null, currentHistorialSociedadDomicilioItem: null })
        this.loadData()
      })
  }

  confirmDeleteGasto(id) {
    this.setState({ confirmDelete: id })
  }

  doDeleteGasto() {
    const { confirmDelete, ejercicio, periodo } = this.state
    this.setState({ confirmDelete: null, gastosLoading: true })
    ElementsDataService.deleteElement('domicilios/gastos', confirmDelete)
      .then(() => {
        ElementsDataService.retrieveElement(`domicilios/gastos/${ejercicio}/${periodo}`, this.state.id)
          .then(r => this.setState({ gastos: r.data, gastosLoading: false }))
      })
  }

  getGastosByPeriodoEjercicio(ejercicio = this.state.ejercicio, periodo = this.state.periodo) {
    this.setState({ ejercicio, periodo, gastosLoading: true })
    ElementsDataService.retrieveElement(`domicilios/gastos/${ejercicio}/${periodo}`, this.state.id)
      .then(r => this.setState({ gastos: r.data, gastosLoading: false }))
      .catch(() => this.setState({ gastosLoading: false }))
  }

  setHistorialItem(historiaItem, field, value) {
    const btnId = `boton_${historiaItem.id}_${field === 'fechaInicio' ? 'desde' : 'hasta'}`
    this.setState({
      selectedSavedButtonId: btnId,
      currentHistorialSociedadDomicilioItem: {
        id: historiaItem.id,
        sociedadId: historiaItem.sociedadId,
        domicilioId: historiaItem.domicilioId,
        fechaInicio: field === 'fechaInicio' ? value : historiaItem.fechaInicio,
        fechaFin: field === 'fechaFin' ? value : historiaItem.fechaFin,
      }
    })
  }

  openGastoForm(gasto = null) {
    if (gasto) {
      this.setState({
        showGastoForm: true, gastoFormMode: 'edit',
        gastoFormId: gasto.id,
        gastoFormTipo: gasto.tipoGasto || '',
        gastoFormCantidad: gasto.cantidad || '',
        gastoFormFecha: gasto.fecha || '',
        gastoFormNotas: gasto.notas || '',
        gastoFormFile: null,
        gastoFormFileUrl: gasto.reciboFileUrl || '',
        gastoFormError: '',
      })
    } else {
      this.setState({
        showGastoForm: true, gastoFormMode: 'new',
        gastoFormId: null,
        gastoFormTipo: '', gastoFormCantidad: '',
        gastoFormFecha: '', gastoFormNotas: '',
        gastoFormFile: null, gastoFormFileUrl: '',
        gastoFormError: '',
      })
    }
    // Small delay so the DOM mounts before we scroll
    setTimeout(() => {
      const el = document.getElementById('gasto-form-inline')
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 80)
  }

  closeGastoForm() {
    this.setState({ showGastoForm: false, gastoFormError: '' })
  }

  submitGastoForm() {
    const {
      id, ejercicio, periodo,
      gastoFormId, gastoFormMode,
      gastoFormTipo, gastoFormCantidad, gastoFormFecha,
      gastoFormNotas, gastoFormFile,
    } = this.state

    let err = ''
    if (!gastoFormTipo)     err += 'Selecciona el tipo de gasto.\n'
    if (!gastoFormCantidad) err += 'Ingresa una cantidad.\n'
    if (!gastoFormFecha)    err += 'Selecciona la fecha.\n'
    else {
      const y = new Date(gastoFormFecha).getFullYear()
      if (y < 1900 || y > 2100 || isNaN(y)) err += `Año inválido (${y}).\n`
    }
    if (err) { this.setState({ gastoFormError: err.trim() }); return }

    this.setState({ gastoFormSaving: true, gastoFormError: '' })
    const fd = new FormData()
    fd.append('gastoId', gastoFormMode === 'edit' ? gastoFormId : -1)
    fd.append('domicilioId', id)
    fd.append('tipoGasto', gastoFormTipo)
    fd.append('cantidad', gastoFormCantidad)
    fd.append('fecha', gastoFormFecha)
    fd.append('notas', gastoFormNotas)
    if (gastoFormFile) fd.append('reciboFile', gastoFormFile)

    ElementsDataService.createElement('domicilios/gastos', fd)
      .then(res => {
        if (res.status === 200) {
          this.setState({ showGastoForm: false, gastoFormSaving: false, gastosLoading: true })
          ElementsDataService.retrieveElement(`domicilios/gastos/${ejercicio}/${periodo}`, id)
            .then(r => this.setState({ gastos: r.data, gastosLoading: false }))
        } else {
          this.setState({ gastoFormSaving: false, gastoFormError: 'Error al guardar. Intenta de nuevo.' })
        }
      })
      .catch(() => this.setState({ gastoFormSaving: false, gastoFormError: 'Error de conexión.' }))
  }

  renderSociedadRow(sociedad) {
    const { selectedSavedButtonId } = this.state
    return (
      <tr key={sociedad.sociedadId}>
        <td style={S.td}>
          <Link to={`/sociedades/reportes/${sociedad.sociedadId}`} style={{ color: T.blue, textDecoration: 'none', fontWeight: 500 }}>
            {sociedad.razonSocialSociedad}
          </Link>
        </td>
        <td style={S.td}>{(() => {
          const sc = sociedad.statusContabilidad
          if (!sc) return <span style={{ color: T.muted }}>—</span>
          const u = sc.toUpperCase()
          const type = (u.includes('INACTIV') || u.includes('SUSPEND') || u.includes('LIQUID') || u.includes('VEND')) ? 'inactivo'
            : u.includes('ACTIV') ? 'activo'
            : 'warn'
          return <Badge type={type}>{sc}</Badge>
        })()}</td>
        <td style={S.td}>{sociedad.clientes?.map((c, i) => <div key={i}>{c.nombreCliente}</div>)}</td>
        <td style={S.td}>
          {sociedad.historialsociedadesDomicilios?.map(h => (
            <div key={h.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <input type="date" defaultValue={h.fechaInicio} style={{ ...S.input, width: 140 }}
                onChange={e => this.setHistorialItem(h, 'fechaInicio', e.target.value)} />
              {selectedSavedButtonId === `boton_${h.id}_desde` &&
                <button style={S.btnSm(T.green, T.greenBg, T.greenBdr)} onClick={() => this.updateFecha()}>Guardar</button>}
            </div>
          ))}
        </td>
        <td style={S.td}>
          {sociedad.historialsociedadesDomicilios?.map(h => (
            <div key={h.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <input type="date" defaultValue={h.fechaFin} style={{ ...S.input, width: 140 }}
                onChange={e => this.setHistorialItem(h, 'fechaFin', e.target.value)} />
              {selectedSavedButtonId === `boton_${h.id}_hasta` &&
                <button style={S.btnSm(T.green, T.greenBg, T.greenBdr)} onClick={() => this.updateFecha()}>Guardar</button>}
            </div>
          ))}
        </td>
      </tr>
    )
  }

  render() {
    const {
      id, tipoVialidad, calle, colonia, cp, estado, municipio,
      numeroExt, numeroInterior, telefono, tipo, notas, tipoInmueble,
      estatus, control, especificaciones, referencias, entreCalle1, entreCalle2,
      listaSociedadesDocumentosPersonasFisicas, gastos,
      portadaData, loading, fotografiasGalleryDataArray,
      periodo, ejercicio, gastosLoading,
      resumenContrato, fechaVencimientoContrato, rentaMensual,
      formaPago, noCuenta, arrendadorName, idArrendadorFileURL,
      propietarioIntermediario, documentoAcreditacionPosesionURL,
      fechaInactivo, comprobanteDomicilioFileUrl,
      contratoArrendamientoFileUrl, croquisFileUrl,
      errorMsg, confirmDelete,
      pfCollapsed, fotosCollapsed,
      showGastoForm, gastoFormMode,
      gastoFormTipo, gastoFormCantidad, gastoFormFecha,
      gastoFormNotas, gastoFormFileUrl,
      gastoFormSaving, gastoFormError,
    } = this.state

    const noNull = v => (v && v !== 'null') ? v : null

    const sociedadesActuales = listaSociedadesDocumentosPersonasFisicas
      ? listaSociedadesDocumentosPersonasFisicas.filter(s => !(s.historialsociedadesDomicilios?.[0]?.fechaFin))
      : []
    const sociedadesAnteriores = listaSociedadesDocumentosPersonasFisicas
      ? listaSociedadesDocumentosPersonasFisicas.filter(s => s.historialsociedadesDomicilios?.[0]?.fechaFin)
      : []

    const personasFisicasFlat = listaSociedadesDocumentosPersonasFisicas
      ? listaSociedadesDocumentosPersonasFisicas.flatMap(s =>
          s.documentos?.flatMap(doc =>
            doc.personasFisicas?.map(pf => ({ ...pf, sociedad: s })) || []
          ) || []
        )
      : []

    const estatusBadge = estatus === 'ACTIVO' ? 'activo' : estatus === 'INACTIVO' ? 'inactivo' : 'default'

    return (
      <div style={S.page}>
        {confirmDelete && (
          <ConfirmModal
            message="¿Estás seguro de que deseas eliminar este gasto? Esta acción no se puede deshacer."
            onConfirm={() => this.doDeleteGasto()}
            onCancel={() => this.setState({ confirmDelete: null })}
          />
        )}

        {/* Header */}
        <div style={S.header} className="no-print">
          <button style={S.btnBack} onClick={() => this.props.history.push('/domicilios')}>
            ‹ Domicilios
          </button>
          <div style={S.title}>Reporte Domicilio</div>
          {estatus && <Badge type={estatusBadge}>{estatus}</Badge>}
          <button style={S.btnEdit} className="no-print" onClick={() => this.props.history.push(`/domicilios/${id}`)}>
            ✏️ Editar
          </button>
          <button style={S.btnPrint} onClick={() => window.print()}>
            🖨️ Imprimir
          </button>
        </div>

        <div style={S.content}>
          {errorMsg && <div style={S.alertErr}>⚠️ {errorMsg}</div>}

          {loading ? (
            <div style={S.spinner}>
              <div style={{ width: 36, height: 36, border: `3px solid ${T.border}`, borderTopColor: T.blue, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              <span style={{ color: T.txt2, fontSize: 14 }}>Cargando domicilio...</span>
              <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
            </div>
          ) : (<>

            {/* Dirección */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>📍 Dirección</span>
                {estatus && <Badge type={estatusBadge}>{estatus}{estatus === 'INACTIVO' && fechaInactivo ? ` (${fechaInactivo})` : ''}</Badge>}
              </div>
              <div style={{ ...S.cardBody }}>
                <div style={{ fontSize: 20, fontWeight: 700, color: T.navy, marginBottom: 16 }}>
                  {tipoVialidad || 'Calle'} {calle} {numeroExt}{numeroInterior ? ` Int. ${numeroInterior}` : ''}
                </div>
                <div style={S.grid3}>
                  <Field label="Colonia" value={colonia} />
                  <Field label="Municipio" value={municipio} />
                  <Field label="Estado" value={estado} />
                  <Field label="Código Postal" value={cp} />
                  <Field label="Teléfono" value={telefono} />
                  <Field label="Tipo de Inmueble" value={noNull(tipoInmueble)} />
                  <Field label="Control" value={control} />
                  <Field label="Tipo" value={tipo} />
                  <Field label="Entre Calles" value={noNull(entreCalle1) && noNull(entreCalle2) ? `${entreCalle1} y ${entreCalle2}` : noNull(entreCalle1) || noNull(entreCalle2) || null} />
                </div>
                {noNull(referencias) && <Field label="Referencias" value={referencias} preWrap />}
                {noNull(especificaciones) && <Field label="Especificaciones" value={especificaciones} preWrap />}
                {notas && <Field label="Notas" value={notas} preWrap />}
              </div>
            </div>

            {/* Contrato */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>📄 Contrato de Arrendamiento</span>
              </div>
              <div style={S.cardBody}>
                <div style={S.grid3}>
                  <Field label="Costo Renta Mensual" value={rentaMensual ? formatMoney(rentaMensual) : null} />
                  <Field label="Fecha Vencimiento" value={fechaVencimientoContrato} />
                  <Field label="Forma de Pago" value={formaPago} />
                  <Field label="Número de Cuenta" value={noCuenta} />
                  <Field label="Nombre Arrendador" value={arrendadorName} />
                  <Field label="Propietario / Intermediario" value={propietarioIntermediario} />
                </div>
                {resumenContrato && <Field label="Resumen Contrato" value={resumenContrato} preWrap />}

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }} className="no-print">
                  <div>
                    <span style={S.label}>Comprobante Domicilio</span>
                    <DownloadBtn fileUrl={comprobanteDomicilioFileUrl}
                      filename={`ComprobanteDomicilio_${calle}_${numeroExt}_${colonia}.pdf`} />
                  </div>
                  <div>
                    <span style={S.label}>Contrato Arrendamiento</span>
                    <DownloadBtn fileUrl={contratoArrendamientoFileUrl}
                      filename={`ContratoArrendamiento_${calle}_${numeroExt}_${colonia}.pdf`} />
                  </div>
                  <div>
                    <span style={S.label}>Doc. Acreditación Posesión</span>
                    <DownloadBtn fileUrl={documentoAcreditacionPosesionURL}
                      filename={`AcreditacionPosesion_${calle}_${numeroExt}_${colonia}.pdf`} />
                  </div>
                  <div>
                    <span style={S.label}>Identificación Arrendador</span>
                    <DownloadBtn fileUrl={idArrendadorFileURL}
                      filename={`IdentificacionArrendador_${calle}_${numeroExt}_${colonia}.pdf`} />
                  </div>
                  <div>
                    <span style={S.label}>Croquis</span>
                    <DownloadBtn fileUrl={croquisFileUrl}
                      filename={`Croquis_${calle}_${numeroExt}_${colonia}.pdf`} />
                  </div>
                </div>
              </div>
            </div>

            {/* Sociedades Actuales */}
            <div style={S.card} className="no-print">
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>🏢 Sociedades Actuales</span>
                <span style={{ fontSize: 13, color: T.txt2, fontWeight: 600 }}>{sociedadesActuales.length} sociedad{sociedadesActuales.length !== 1 ? 'es' : ''}</span>
              </div>
              {sociedadesActuales.length === 0
                ? <div style={S.noData}>Sin sociedades actuales</div>
                  : <div style={{ overflowX: 'auto' }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          {['Sociedad', 'Estatus Contable', 'Cliente', 'Desde', 'Hasta'].map(h => <th key={h} style={S.th}>{h}</th>)}
                        </tr>
                      </thead>
                      <tbody>{sociedadesActuales.map(s => this.renderSociedadRow(s))}</tbody>
                    </table>
                  </div>
              }
            </div>

            {/* Sociedades Anteriores */}
            {sociedadesAnteriores.length > 0 && (
              <div style={S.card} className="no-print">
                <div style={S.cardHeader}>
                  <span style={S.cardTitle}>🏛 Sociedades Anteriores</span>
                  <span style={{ fontSize: 13, color: T.txt2, fontWeight: 600 }}>{sociedadesAnteriores.length}</span>
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={S.table}>
                    <thead>
                      <tr>{['Sociedad', 'Estatus Contable', 'Cliente', 'Desde', 'Hasta'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
                    </thead>
                    <tbody>{sociedadesAnteriores.map(s => this.renderSociedadRow(s))}</tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Personas Físicas */}
            {personasFisicasFlat.length > 0 && (
              <div style={S.card} className="no-print">
                <div style={{ ...S.cardHeader, cursor: 'pointer', userSelect: 'none' }}
                  onClick={() => this.setState(s => ({ pfCollapsed: !s.pfCollapsed }))}>
                  <span style={S.cardTitle}>👤 Personas Físicas</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 13, color: T.txt2, fontWeight: 600 }}>{personasFisicasFlat.length}</span>
                    <span style={{ color: T.muted, fontSize: 13, transition: 'transform .2s', display: 'inline-block', transform: pfCollapsed ? 'rotate(0deg)' : 'rotate(180deg)' }}>▼</span>
                  </div>
                </div>
                {!pfCollapsed && (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          <th style={S.th}>Persona Física</th>
                          <th style={S.th}>Sociedad</th>
                        </tr>
                      </thead>
                      <tbody>
                        {personasFisicasFlat.map((pf, i) => (
                          <tr key={i}>
                            <td style={S.td}>
                              <Link to={`/personas-fisicas/reportes/${pf.personaFisicaId}`} style={{ color: T.blue, textDecoration: 'none', fontWeight: 500 }}>
                                {pf.personaFisicaNombre}
                              </Link>
                            </td>
                            <td style={S.td}>
                              <Link to={`/sociedades/reportes/${pf.sociedad.sociedadId}`} style={{ color: T.txt, textDecoration: 'none' }}>
                                {pf.sociedad.razonSocialSociedad}
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* Galería */}
            <div style={S.card}>
              <div style={{ ...S.cardHeader, cursor: 'pointer', userSelect: 'none' }}
                onClick={() => this.setState(s => ({ fotosCollapsed: !s.fotosCollapsed }))}>
                <span style={S.cardTitle}>📷 Fotografías</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <button style={S.btnEdit} className="no-print"
                    onClick={e => { e.stopPropagation(); this.props.history.push(`/domicilios/galeria/editar/${id}`) }}>
                    ✏️ Editar Fotos
                  </button>
                  <span style={{ color: T.muted, fontSize: 13, transition: 'transform .2s', display: 'inline-block', transform: fotosCollapsed ? 'rotate(0deg)' : 'rotate(180deg)' }}>▼</span>
                </div>
              </div>
              {!fotosCollapsed && (
                !portadaData && fotografiasGalleryDataArray.length === 0
                  ? <div style={S.noData}>Sin fotografías cargadas</div>
                  : <>
                      {portadaData && (
                        <div style={{ padding: '20px 24px' }}>
                          <div style={{ ...S.label, marginBottom: 10 }}>FACHADA</div>
                          <div style={S.photoCover}>
                            <img src={portadaData} alt="Fachada" style={S.photoImg} />
                          </div>
                        </div>
                      )}
                      {fotografiasGalleryDataArray.filter(Boolean).length > 0 && (
                        <div style={{ padding: '0 24px 20px' }}>
                          <div style={{ ...S.label, marginBottom: 10 }}>INTERIORES</div>
                          <div style={S.photoGrid}>
                            {fotografiasGalleryDataArray.filter(Boolean).map((img, i) => (
                              <div key={i} style={S.photo}>
                                <img src={img} alt={`Interior ${i + 1}`} style={S.photoImg} />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
              )}
            </div>

            {/* ── Gastos ── */}
            <div style={S.card} className="no-print">

              {/* Header */}
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>💰 Gastos del Domicilio</span>
                {!showGastoForm && (
                  <button style={S.btnEdit} onClick={() => this.openGastoForm()}>
                    + Agregar Gasto
                  </button>
                )}
              </div>

              {/* ── Inline form ── */}
              <style>{`
                @keyframes gf-slideDown {
                  from { opacity: 0; transform: translateY(-10px); max-height: 0; }
                  to   { opacity: 1; transform: translateY(0);     max-height: 600px; }
                }
                @keyframes gf-slideUp {
                  from { opacity: 1; max-height: 600px; }
                  to   { opacity: 0; max-height: 0; }
                }
                .gasto-form-wrap {
                  animation: gf-slideDown 0.28s cubic-bezier(0.34,1.3,0.64,1) forwards;
                  overflow: hidden;
                }
                .gf-field label {
                  display: block;
                  font-size: 11px; font-weight: 700; text-transform: uppercase;
                  letter-spacing: .07em; color: #94a3b8; margin-bottom: 5px;
                }
                .gf-input {
                  width: 100%; padding: 9px 12px;
                  border: 1.5px solid #e2e8f0; border-radius: 10px;
                  font-size: 14px; color: #1e293b; background: #fff;
                  outline: none; box-sizing: border-box; transition: border-color .15s;
                  font-family: inherit;
                }
                .gf-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
                .gf-select {
                  width: 100%; padding: 9px 12px;
                  border: 1.5px solid #e2e8f0; border-radius: 10px;
                  font-size: 14px; color: #1e293b; background: #fff;
                  outline: none; cursor: pointer; box-sizing: border-box;
                  transition: border-color .15s; font-family: inherit; appearance: auto;
                }
                .gf-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
                .gf-btn-save {
                  display: inline-flex; align-items: center; gap: 7px;
                  background: #3b82f6; color: #fff; border: none;
                  border-radius: 10px; padding: 9px 20px;
                  font-size: 14px; font-weight: 600; cursor: pointer;
                  transition: background .15s, transform .1s; font-family: inherit;
                }
                .gf-btn-save:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); }
                .gf-btn-save:disabled { opacity: .6; cursor: not-allowed; }
                .gf-btn-cancel {
                  display: inline-flex; align-items: center; gap: 6px;
                  background: #f1f5f9; color: #64748b;
                  border: 1.5px solid #e2e8f0; border-radius: 10px; padding: 9px 16px;
                  font-size: 14px; font-weight: 600; cursor: pointer;
                  transition: all .15s; font-family: inherit;
                }
                .gf-btn-cancel:hover { background: #e2e8f0; color: #1e293b; }
                .gf-spinner {
                  width: 16px; height: 16px; border-radius: 50%;
                  border: 2px solid rgba(255,255,255,.4);
                  border-top-color: #fff;
                  animation: gf-spin .6s linear infinite; display: inline-block;
                }
                @keyframes gf-spin { to { transform: rotate(360deg); } }
              `}</style>

              {showGastoForm && (
                <div className="gasto-form-wrap" id="gasto-form-inline">
                  <div style={{
                    margin: '0 24px 0', padding: '20px 24px',
                    background: 'linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%)',
                    borderRadius: 14, border: '1.5px solid #dbeafe',
                    marginTop: 16, marginBottom: 4,
                  }}>
                    {/* Form title */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, color: T.navy }}>
                        {gastoFormMode === 'edit' ? '✏️ Editar gasto' : '➕ Nuevo gasto'}
                      </div>
                      <button className="gf-btn-cancel" style={{ padding: '5px 10px', fontSize: 12 }}
                        onClick={() => this.closeGastoForm()}>✕</button>
                    </div>

                    {/* Error */}
                    {gastoFormError && (
                      <div style={{ ...S.alertErr, marginBottom: 16, whiteSpace: 'pre-line' }}>
                        ⚠️ {gastoFormError}
                      </div>
                    )}

                    {/* Row 1: Tipo + Cantidad + Fecha */}
                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 14, marginBottom: 14 }}>
                      <div className="gf-field">
                        <label>Tipo de Gasto</label>
                        <select className="gf-select" value={gastoFormTipo}
                          onChange={e => this.setState({ gastoFormTipo: e.target.value })}>
                          <option value="">— Seleccionar —</option>
                          <option value="ARRENDAMIENTO">ARRENDAMIENTO</option>
                          <option value="ELECTRICIDAD">ELECTRICIDAD</option>
                          <option value="AGUA">AGUA</option>
                          <option value="TELEFONIA E INTERNET">TELEFONÍA E INTERNET</option>
                          <option value="MANTENIMIENTO">MANTENIMIENTO</option>
                          <option value="OTROS">OTROS</option>
                        </select>
                      </div>
                      <div className="gf-field">
                        <label>Cantidad</label>
                        <input className="gf-input" type="number" min="0" step="0.01"
                          placeholder="$ 0.00" value={gastoFormCantidad}
                          onChange={e => this.setState({ gastoFormCantidad: e.target.value })} />
                      </div>
                      <div className="gf-field">
                        <label>Fecha</label>
                        <input className="gf-input" type="date" value={gastoFormFecha}
                          onChange={e => this.setState({ gastoFormFecha: e.target.value })} />
                      </div>
                    </div>

                    {/* Row 2: Notas + Archivo */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 20 }}>
                      <div className="gf-field">
                        <label>Notas</label>
                        <input className="gf-input" type="text" placeholder="Observaciones opcionales"
                          value={gastoFormNotas}
                          onChange={e => this.setState({ gastoFormNotas: e.target.value.toUpperCase() })} />
                      </div>
                      <div className="gf-field">
                        <label>Recibo {gastoFormFileUrl && <span style={{ color: T.green, fontWeight: 600 }}>✓ archivo existente</span>}</label>
                        <input className="gf-input" type="file" accept=".pdf,.jpg,.jpeg,.png"
                          style={{ padding: '6px 10px', cursor: 'pointer' }}
                          onChange={e => this.setState({ gastoFormFile: e.target.files[0] })} />
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display: 'flex', gap: 10 }}>
                      <button className="gf-btn-save" disabled={gastoFormSaving}
                        onClick={() => this.submitGastoForm()}>
                        {gastoFormSaving
                          ? <><span className="gf-spinner" /> Guardando…</>
                          : <><span>✓</span> Guardar</>}
                      </button>
                      <button className="gf-btn-cancel" disabled={gastoFormSaving}
                        onClick={() => this.closeGastoForm()}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                  {/* Spacer */}
                  <div style={{ height: 4 }} />
                </div>
              )}

              {/* Filtros periodo/ejercicio */}
              <div style={{ padding: '16px 24px', borderBottom: `1px solid ${T.border}`, display: 'flex', gap: 16, alignItems: 'flex-end' }}>
                <div>
                  <label style={S.label}>Ejercicio</label>
                  <select style={{ ...S.select, width: 110 }} value={String(ejercicio)}
                    onChange={e => this.getGastosByPeriodoEjercicio(e.target.value, periodo)}>
                    {EJERCICIOS.map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Periodo</label>
                  <select style={{ ...S.select, width: 150 }} value={periodo}
                    onChange={e => this.getGastosByPeriodoEjercicio(ejercicio, e.target.value)}>
                    {MESES.map(m => <option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
              </div>

              {/* Tabla gastos */}
              {gastosLoading
                ? <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}><div className="spinner" /></div>
                : gastos.length === 0
                  ? <div style={S.noData}>Sin gastos para {periodo} {ejercicio}</div>
                  : <div style={{ overflowX: 'auto' }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          {['Concepto', 'Cantidad', 'Fecha', 'Notas', 'Recibo', '', ''].map((h, i) => <th key={i} style={S.th}>{h}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {gastos.map(g => (
                          <tr key={g.id}>
                            <td style={S.td}>{g.tipoGasto}</td>
                            <td style={{ ...S.td, fontWeight: 600 }}>{formatMoney(g.cantidad)}</td>
                            <td style={S.td}>{g.fecha}</td>
                            <td style={{ ...S.td, color: T.txt2, maxWidth: 200 }}>{g.notas || '—'}</td>
                            <td style={S.td}>
                              <DownloadBtn fileUrl={g.reciboFileUrl}
                                filename={`RECIBO_${g.tipoGasto}_${calle}_${g.fecha}.pdf`} />
                            </td>
                            <td style={{ ...S.td, width: 40 }}>
                              <button style={S.btnSm(T.blue, '#eff6ff', '#bfdbfe')}
                                onClick={() => this.openGastoForm(g)}>
                                ✏️
                              </button>
                            </td>
                            <td style={{ ...S.td, width: 40 }}>
                              <button style={S.btnSm(T.red, T.redBg, T.redBdr)}
                                onClick={() => this.confirmDeleteGasto(g.id)}>
                                🗑
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Total */}
                    <div style={{ padding: '12px 24px', borderTop: `2px solid ${T.border}`, display: 'flex', justifyContent: 'flex-end', gap: 8, alignItems: 'center' }}>
                      <span style={{ fontSize: 13, color: T.txt2, fontWeight: 600 }}>TOTAL:</span>
                      <span style={{ fontSize: 16, fontWeight: 700, color: T.navy }}>
                        {formatMoney(gastos.reduce((acc, g) => acc + (Number(g.cantidad) || 0), 0))}
                      </span>
                    </div>
                  </div>
              }
            </div>

          </>)}
        </div>
      </div>
    )
  }
}

export default DomicilioReporteComponent
